<!--
  Popover info prodotti — pattern Diakonix native (v2.11.0 J.3).
  Aperto via PopoverController Ionic con cssClass 'product-list-popover'.
  Mostra elenco prodotti dell'ordine (read-only) con stato op_checked.
-->
<div class="pi-card">
  <header class="pi-header">
    <i class="bx bx-package"></i> 
    <h2>Prodotti dell'ordine</h2>
    <button
      type="button"
      class="pi-close"
      aria-label="Chiudi"
      (click)="close()"
    >
      <i class="bx bx-x"></i>
    </button>
  </header>

  <div class="pi-body">
    @if (loading) {
      <div class="pi-loading">
        <i class="bx bx-loader-alt bx-spin"></i>
        Caricamento...
      </div>
    } @else if (!order?.products?.length) {
      <p class="pi-empty">Nessun prodotto disponibile.</p>
    } @else {
      <ul class="pi-list">
        @for (prod of order.products; track $index) {
          <li class="pi-item" [class.pi-item--checked]="prod.op_checked">
            <div class="pi-item-main">
              <span class="pi-code">{{ prod.op_code }}</span>
              <span class="pi-desc">{{ prod.op_description }}</span>
            </div>
            <span class="pi-qty">
              <strong>{{ prod.op_qta_picked || 0 }}</strong>
              <span class="pi-qty-sep">/</span>
              <span>{{ prod.op_qta }}</span>
              <span class="pi-qty-unit">pz</span>
            </span>
          </li>
        }
      </ul>
    }
  </div>
</div>
